import produce from 'immer';
import { INITILIZE_INJECTOR } from '../constants/actions/mobizActions';
import IMobizReducer from '../interfaces/reducers/mobizReducer';

const initialValues: IMobizReducer = {
	injector: '',
};

const mobizReducer = produce((draft: IMobizReducer, action) => {
	switch (action.type) {
		case INITILIZE_INJECTOR: {
			draft.injector = action.payload.injector;
			break;
		}
		default:
			break;
	}
}, initialValues);

export default mobizReducer;
